export enum TimeUnit {
  DAY = 'days',
  HOUR = 'hours',
}
